import DeleteAccountForm from './DeleteAccountForm'
export default DeleteAccountForm
